import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { ErrorBoundary } from 'components/Errors';
import Loader from 'components/Loader';
import { ServerStatusContext } from 'utils/serverStatus';

const NotFound = loadable(() => import(/* webpackChunkName: "NotFound" */ './NotFound'), {
  fallback: <Loader visible />,
});

// reportStatus defaults to true for route-level not-found pages. Pages that
// reuse this component as an in-page message for a valid route (e.g. the
// ExpressCheckin tenant gate) pass reportStatus={false} to keep HTTP 200.
const AsyncNotFound = ({ reportStatus = true }) => {
  const serverStatus = useContext(ServerStatusContext);
  if (serverStatus && reportStatus) {
    serverStatus.statusCode = 404;
  }

  return (
    <ErrorBoundary>
      <NotFound />
    </ErrorBoundary>
  );
};

AsyncNotFound.propTypes = {
  reportStatus: PropTypes.bool,
};

export default AsyncNotFound;
